import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'abc-unauthorized',
  imports: [],
  templateUrl: 'unauthorized.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Unauthorized {}
